<template>
	<div class="work-wrapper">
		<template v-for="iframe in iframeList">
			<navigation-layout
				v-show="$route.name === iframe.code"
				:key="iframe.code"
				:url="iframe.url"
				:code="iframe.code"
			>
			</navigation-layout>
		</template>

	</div>
</template>

<script>
import { mapState } from "vuex";
import NavigationLayout from "@/layouts/NavigationLayout.vue";

export default {
	name: "NavigationView",
	components: {NavigationLayout},
	computed: {
		...mapState({
			iframeList: state => state.tabs.navigationIframeList,
		}),
	},
	data() {
		return {
		}
	},
	methods: {
	}
}
</script>

<style scoped lang="less">
.work-wrapper {
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: flex-start;
  background: #f2f3f5;
  border-radius: 4px;
  width: 0;
	.tabs-wrapper {
		display: flex;
		width: 100%;
		height: 45px;
		background-color: #d8dfe6;
    padding: 10px 15px 0 15px;
    border-radius: 4px;
    /deep/ .ant-tabs-bar {
      margin: 0;
      .ant-tabs-tab {
        width: 188px;
        height: 35px;
        line-height: 35px;
        border: 0;
        border-radius: 8px 8px 0 0;
        margin-right: 0px;
        padding: 0 20px 0 20px;
        background: none;
        position: relative;
        font-size: 13px;
        &:after {
          content: '';
          position: absolute;
          width: 1px;
          height: 20px;
          z-index: 9;
          right: 0px;
          top: 8px;
          background: #bfbfbf;
        }
        &.ant-tabs-tab-active {
          background: url("~@/assets/home/tab-bg.png");
          &:after {
            right: auto;
            left: -1px;
            background: #d8dfe6;
          }
        }
        .ant-tabs-tab-icon {
          color: #05051a;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 90%;
          img {
            height: 16px;
            margin-right: 5px;
            vertical-align: -3px;
            border-radius: 3px;
          }
        }
        .ant-tabs-close-x {
          float: right;
          margin-top: 12px;
          color: #787889;
        }
        &:first-child {
          .ant-tabs-tab-icon img {
            border-radius: 0;
          }
        }
      }
      .ant-tabs-tab-arrow-show {
        margin-top: -3px;
      }
    }
	}
}
</style>
